<btl-cms-block
    [replaceContent]="{ regex: linksRegex, replace: originDomain }"
    [isCustomUrl]="true"
    [blockId]="cmsBlockId"
></btl-cms-block>
